import { accountApi } from "../../config/apiConfig";
import {
  CreateVendorConfigPayload,
  UpdateVendorConfigPayload,
  VendorAssetType,
  VendorConfig,
} from "../../types/onboarding";

// Manufacturer configuration catalogue (CWA-91). Decides what a customer
// receives with their configuration email: whether a setup guide and/or a
// security certificate is required per wallbox manufacturer, and the files.

// GET /admin/vendor-configs — NOTE the API returns a bare array, not an
// envelope, so there is nothing to unwrap here.
export const listVendorConfigs = async (): Promise<VendorConfig[]> => {
  const response = await accountApi.get("admin/vendor-configs");
  return response.data ?? [];
};

// GET /admin/vendor-configs/{vendorId} — 404 when unknown.
export const getVendorConfig = async (
  vendorId: string
): Promise<VendorConfig> => {
  const response = await accountApi.get(
    `admin/vendor-configs/${encodeURIComponent(vendorId)}`
  );
  return response.data;
};

// POST /admin/vendor-configs — 201. Also acts as an upsert on the identifier.
export const createVendorConfig = async (
  payload: CreateVendorConfigPayload
): Promise<VendorConfig> => {
  const response = await accountApi.post("admin/vendor-configs", payload);
  return response.data;
};

// PUT /admin/vendor-configs/{vendorId} — partial merge. A null never clears a
// stored value on the backend, so callers only send fields they mean to set.
export const updateVendorConfig = async (
  vendorId: string,
  payload: UpdateVendorConfigPayload
): Promise<VendorConfig> => {
  const response = await accountApi.put(
    `admin/vendor-configs/${encodeURIComponent(vendorId)}`,
    payload
  );
  return response.data;
};

// POST /admin/vendor-configs/{vendorId}/upload?assetType=… — 204.
// Two things the API is strict about: the asset type is a camelCase QUERY
// parameter (not a form field), and the file part must be named "file".
// The shared accountApi sets Content-Type: application/json for every request,
// which would break the upload — clearing it lets the browser write the
// multipart boundary itself. The auth interceptor still applies.
export const uploadVendorAsset = async (
  vendorId: string,
  assetType: VendorAssetType,
  file: File
): Promise<void> => {
  const form = new FormData();
  form.append("file", file);
  await accountApi.post(
    `admin/vendor-configs/${encodeURIComponent(vendorId)}/upload?assetType=${assetType}`,
    form,
    { headers: { "Content-Type": undefined } }
  );
};
